import React from 'react';

const SubmitButton = ({ onClick, label = 'Submit', disabled = false }) => {
    return (
        <button
            onClick={onClick}
            disabled={disabled}
            style={{
                marginLeft: '10px',
                padding: '10px 20px',
                fontSize: '16px',
                backgroundColor: disabled ? '#ccc' : '#007BFF',
                color: '#fff',
                border: '2px solid #fff',
                borderRadius: '5px',
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.6 : 1,
            }}
        >
            {label}
        </button>
    );
};

export default SubmitButton;